import { FaRocket } from "@onemind-services-llc/react-icons-ng/fa";
import { GiTeamIdea } from "@onemind-services-llc/react-icons-ng/gi";
import {
  RiPassValidLine,
  RiUserSettingsFill,
} from "@onemind-services-llc/react-icons-ng/ri";

export const MIGRATION_CONSTANTS = {
  TITLE: "OneMind’s Migration Playbook for EC2 to Zadara",
  ITEMS: [
    {
      icon: FaRocket,
      title: "Discovery & Assessment",
      text: "Analyze your AWS EC2 instances, attached volumes, security groups, and networking configuration to create an optimized Zadara target plan.",
    },
    {
      icon: GiTeamIdea,
      title: "Architecture Planning",
      text: "Define the storage (zStorage), compute (zCompute), and network (zNetworking) layout within Zadara to support your migrated workload.",
    },
    {
      icon: RiUserSettingsFill,
      title: "Migration Execution",
      text: "Use tools like Xmost Migrator and AWS-compatible APIs to securely and efficiently replicate your EC2 environments to Zadara.",
    },
    {
      icon: RiPassValidLine,
      title: "Cutover & Validation",
      text: "Test application performance, validate network configurations, and complete DNS or IP handoff before final cutover.",
    },
  ],
};
